import React from "react";
import PropTypes from "prop-types";

export default function Status({ active }) {
  if (!active) {
    return (
      <span className="label label-danger">
        <i className="fa fa-warning" />
        &nbsp;&nbsp;Deactivated
      </span>
    );
  }

  return false;
}

Status.propTypes = {
  active: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/users/components/Search/Status.jsx